import { defineComponent as h, onMounted as y, computed as C, watch as i, openBlock as F, createElementBlock as $, Fragment as B, renderSlot as a, normalizeProps as t, guardReactiveProps as E, unref as l, mergeProps as s, createCommentVNode as c } from "vue";
import { shallowEquals as P } from "../../utils/object.js";
import { debounce as w } from "../../utils/debounce.js";
import { useLoader as L } from "./composables/useLoader.js";
const N = /* @__PURE__ */ h({
  __name: "v-loader",
  props: {
    args: {},
    poll: { default: null },
    debounce: {},
    fn: {},
    fallback: { default: null },
    collate: {},
    flushOnError: { type: Boolean }
  },
  emits: ["loaded"],
  setup(f, { emit: g }) {
    const o = f, v = g, { data: u, pending: p, error: d, load: m, onLoad: b, executionCount: k } = L(o);
    y(() => {
      m(o.args);
    });
    const r = C(() => {
      const e = () => m(o.args);
      return o.debounce ? w(e, o.debounce) : e;
    });
    return i(
      () => o.args,
      (e, n) => {
        P(e, n) || r.value();
      }
    ), b((e) => {
      v("loaded", e), o.poll && setTimeout(() => r.value(), o.poll);
    }), i(
      () => o.poll,
      (e, n) => {
        n === null && e !== null && r.value();
      }
    ), (e, n) => (F(), $(B, null, [
      a(e.$slots, "default", t(E({ data: l(u), pending: l(p), error: l(d), executionCount: l(k), reload: r.value }))),
      l(u) !== null ? a(e.$slots, "data", t(s({ key: 0 }, { data: l(u), reload: r.value }))) : c("", !0),
      l(p) ? a(e.$slots, "pending", t(s({ key: 1 }, { reload: r.value }))) : c("", !0),
      l(d) ? a(e.$slots, "error", t(s({ key: 2 }, { error: l(d), reload: r.value }))) : c("", !0)
    ], 64));
  }
});
export {
  N as default
};
